document.addEventListener('DOMContentLoaded', function() {

    FS('.reviews .filter-select-item', 'all').onClick(function () {
        let selected = FS(this);
        let rating = selected.getData('type');


       //selected.addUniqueClass('filter-select-item--selected');

        FS('.reviews .filter-select-item--selected').removeClass('filter-select-item--selected');
        FS(this).addClass('filter-select-item--selected');



        FS('.reviews__item', 'all').elements().forEach(review => {
            let review_obj = FS(review);
            if(rating === 'all'){
                review_obj.show();
            }else{
                if(review_obj.getData('rating') === rating){
                    review_obj.show();
                }else{
                    review_obj.hide();
                }
            }


        });

    });








});